var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.625 1.625L7.96875 2L8.34375 1.65625C9.375 0.625 10.8438 0.15625 12.25 0.40625C14.4062 0.75 16 2.625 16 4.8125V4.96875C16 6.28125 15.4375 7.53125 14.5 8.40625L8.84375 13.6875C8.625 13.9062 8.3125 14 8 14C7.65625 14 7.34375 13.9062 7.125 13.6875L1.46875 8.40625C0.53125 7.53125 0 6.28125 0 4.96875V4.8125C0 2.625 1.5625 0.75 3.71875 0.40625C5.125 0.15625 6.59375 0.625 7.625 1.625C7.625 1.65625 7.59375 1.625 7.625 1.625ZM7.96875 4.125L6.5625 2.6875C5.875 2.03125 4.90625 1.71875 3.96875 1.875C2.53125 2.125 1.5 3.34375 1.5 4.8125V4.96875C1.5 5.875 1.84375 6.71875 2.5 7.3125L8 12.4375L13.4688 7.3125C14.125 6.71875 14.5 5.875 14.5 4.96875V4.8125C14.5 3.34375 13.4375 2.125 12 1.875C11.0625 1.71875 10.0938 2.03125 9.40625 2.6875L7.96875 4.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteHeart);
export default __webpack_public_path__ + "static/media/white-heart.877d1c3c59e3a021761677c14ea67564.svg";
export { ForwardRef as ReactComponent };